<template>
    <div class="scroll" :class="{show:isActive}">
        <div class="toTop" id="toTop" @click="toTop(step)">
          <i class="el-icon-top"></i>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'backtop',
    data() {
      return {
        isActive: false
      };
    },
    props: {
      step: { // 控制速度
        type: Number,
        default: 200
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll(e) {
        if (document.documentElement.scrollTop > 100) {
          this.isActive = true;
        } else {
          this.isActive = false;
        }
      },
      toTop(step) {
        document.documentElement.scrollTop -= step;
        if (document.documentElement.scrollTop > 0) {
          var time = setTimeout(() => this.toTop(step), 15);
        } else {
          clearTimeout(time);
        }
      }

    }

  };

</script>
<style lang='scss' scoped>
    .scroll {
        position: fixed;
        bottom: 40px;
        right: 40px;
        transition: 0.3s;
        opacity: 0;
        .toTop {
          font-size: 3rem;
          color: #fff;
          border: 3px solid #fff;
        }
    }
    .show {
      opacity: 1;
    }

</style>



// WEBPACK FOOTER //
// src/base/backtop/index.vue